import { render, staticRenderFns } from "./SemesterSubjectForm.vue?vue&type=template&id=5aeb86ee&scoped=true&"
import script from "./SemesterSubjectForm.ts?vue&type=script&lang=js&"
export * from "./SemesterSubjectForm.ts?vue&type=script&lang=js&"
import style0 from "./SemesterSubjectForm.css?vue&type=style&index=0&id=5aeb86ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aeb86ee",
  null
  
)

export default component.exports